import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName=''
        } = executionObject;

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });
    
        let resolvedParams = parsedParameters['accumulator'];
        let recaptchaSiteKey = resolvedParams.recaptchaSiteKey;
        let recaptchaSecretKey = resolvedParams.recaptchaSecretKey;
        let recaptchaAction = resolvedParams.recaptchaAction;
        let minimumScore = resolvedParams.minimumScore;

        if(
            !recaptchaSiteKey ||
            typeof recaptchaSiteKey !== 'string'
        ){
            console.log('Invalid recaptcha site key');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Invalid recaptcha site key.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            !recaptchaSecretKey ||
            typeof recaptchaSecretKey !== 'string'
        ){
            console.log('Invalid recaptcha secret key');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Invalid recaptcha secret key.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            !recaptchaAction ||
            typeof recaptchaAction !== 'string'
        ){
            console.log('Invalid recaptcha action');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Invalid recaptcha action.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            !minimumScore ||
            typeof minimumScore !== 'number'
        ){
            console.log('Invalid minimum score');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Invalid minimum score.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }
        
        let variableCopy = parsedParameters['variableObject'];
        let recaptchaToken = '';
        
        await new Promise((resolve) => {
            window.grecaptcha.ready(resolve);
        });

        // Now execute and AWAIT the token
        recaptchaToken = await window.grecaptcha.execute(recaptchaSiteKey, {
            action: recaptchaAction
        });

        if(
            !recaptchaToken ||
            typeof recaptchaToken !== 'string'
        ){
            console.log('Invalid recaptcha token');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Error while generating recaptcha token.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let payload = {
            recaptchaToken,
            minimumScore, 
            recaptchaSecretKey,
            recaptchaAction
        }

        let encryptedPayload = encryptDecrypt(
            JSON.stringify({
                payload,
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let response = await fetch(
            `${config.devServerProxy}/api/generaltaskparser/validaterecaptchav3token`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache'
                },
                body : JSON.stringify({
                    encryptedPayload
                })
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/executeRecaptchaV3Parser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}